import { render, staticRenderFns } from "./file-history.vue?vue&type=template&id=71c512dd&scoped=true"
import script from "./file-history.vue?vue&type=script&lang=js"
export * from "./file-history.vue?vue&type=script&lang=js"
import style0 from "./file-history.vue?vue&type=style&index=0&id=71c512dd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c512dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c512dd')) {
      api.createRecord('71c512dd', component.options)
    } else {
      api.reload('71c512dd', component.options)
    }
    module.hot.accept("./file-history.vue?vue&type=template&id=71c512dd&scoped=true", function () {
      api.rerender('71c512dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/file-history.vue"
export default component.exports